var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg5 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M99,55a12.83,12.83,0,0,0-1.22-5.45c-.08-.43-.17-.86-.29-1.29L89,27.16,88.92,27C85.94,18.11,81.7,9.9,71,9.9H29.87c-11,0-14.9,8.41-17.95,17L3,48.07A13,13,0,0,0,1,55v6.57a12.91,12.91,0,0,0,.35,3A5.19,5.19,0,0,0,1,66.39V85.91A5.19,5.19,0,0,0,6.18,91.1H16.95a5.18,5.18,0,0,0,5.18-5.19V76.15H78.49v9.76a5.18,5.18,0,0,0,5.18,5.19H93.82A5.19,5.19,0,0,0,99,85.91V66.39a5.23,5.23,0,0,0-.35-1.85,12.92,12.92,0,0,0,.35-3V55ZM18.24,29c3.39-9.56,6.12-12.48,11.63-12.48H71c5.48,0,8.52,3.25,11.62,12.44l6.21,12.59a19,19,0,0,0-6.61-1.17H17.82a19,19,0,0,0-6,1Zm5.33,35H12.23a3.7,3.7,0,0,1,0-7.4H23.58a3.7,3.7,0,1,1,0,7.4Zm40.1-.74H37.27a2.34,2.34,0,1,1,0-4.69h26.4a2.34,2.34,0,1,1,0,4.69Zm23.81.74H76.14a3.7,3.7,0,0,1,0-7.4H87.49a3.7,3.7,0,1,1,0,7.4Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/5.dcf1025b.svg";
export { ForwardRef as ReactComponent };